<style lang="scss">
  @import "@/assets/scss/vuexy/pages/GeneralMap.scss";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
</style>
<style>
  .container-items{
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    justify-content: center;
  }
  .leaflet-popup-content{
    width: 300px!important;
  }

  .filter-container{
    width: 245px;
  }
</style>
<template>
  <div class="item-grid-view vx-row match-height mt-4">
    <div class="vx-col w-full">
      <vx-card class="grid-view-item mb-base overflow-hidden">

        <div class="map-container" v-if="status_mapa">
            <l-map style="height: 100%; overflow: hidden;" :zoom="17" :center="center" ref="mymap">
                <l-control-layers
                  :position="layersPosition"
                  :collapsed="true"
                  :sort-layers="true"
                />
                <l-control position="bottomright">
                  <div class="filter-container bg-white border-2 border-solid border-grey py-2 px-4 rounded-lg mt-1">
                    <div class="font-bold mb-2">{{$t('Labels.Show')+' '+$t('Labels.Type')+'s'}}</div>
                    <div class="container-alerts-control">
                      <vs-checkbox v-model="allSelected"  class="p-1  rounded-lg"><span class="uppercase font-bold">{{$t('Labels.All')}}</span></vs-checkbox>
                      <vs-checkbox class="p-1 rounded-lg" v-model="typesSelected" vs-value="A">
                        <iconAgro  class="inline-block align-middle ml-1" iconName="" :width="18" :height="18" iconColor="#14A5FF"/>
                        <div class="inline-block align-middle ml-1">{{$t('Labels.Agro')}}</div>
                      </vs-checkbox>
                      <vs-checkbox class="p-1 rounded-lg" v-model="typesSelected" vs-value="F">
                         <iconAirflow class="inline-block align-middle ml-1" iconName="" :width="18" :height="18" iconColor="#14A5FF"/>
                         <div class="inline-block align-middle ml-1">{{$t('Labels.AirFlow')}}</div>
                      </vs-checkbox>
                      <vs-checkbox class="p-1 rounded-lg" v-model="typesSelected" vs-value="P">
                        <iconDoor class="inline-block align-middle ml-1" iconName="" :width="18" :height="18" iconColor="#14A5FF"/>
                        <div class="inline-block align-middle ml-1">{{$t('Labels.DoorsSensor')}}</div>
                      </vs-checkbox>
                      <vs-checkbox class="p-1 rounded-lg" v-model="typesSelected" vs-value="E">
                        <iconEnergy class="inline-block align-middle ml-1" :width="18" :height="18" iconColor="#14A5FF"/>
                        <div class="inline-block align-middle ml-1">{{$t('Labels.Energy')}}</div>
                      </vs-checkbox>
                      <vs-checkbox class="p-1 rounded-lg" v-model="typesSelected" vs-value="T">
                        <iconEnv class="inline-block align-middle ml-1" iconName="" :width="18" :height="18" iconColor="#14A5FF"/>
                        <div class="inline-block align-middle ml-1">{{$t('Labels.EnvTemperature')}}</div>
                      </vs-checkbox>
                    </div>
                  </div>
                </l-control>
                <l-tile-layer
                    v-for="tileProvider in tileProviders"
                    :key="tileProvider.name"
                    :name="tileProvider.name"
                    :visible="tileProvider.visible"
                    :url="tileProvider.url"
                    layer-type="base"
                />
                <v-marker-cluster>
                  <l-marker
                    v-for="marker in markers"
                    :key="marker.id"
                    :visible="marker.visible"
                    :draggable="marker.draggable"
                    :lat-lng.sync="marker.position"
                  >
                    <l-icon :icon-anchor="staticAnchor" :class-name="marker.state === '0' ? 'bg-cyan p-1 rounded-full w-10 h-10' :'bg-danger p-1 rounded-full w-10 h-10'">
                      <iconEnergy v-if="marker.device === 'E'" :width="25" :height="25" iconColor="#FFFF"/>
                      <iconAgro v-else-if="marker.device === 'A'"  :width="25" :height="25" iconColor="#FFFF"/>
                      <iconDoor v-else-if="marker.device === 'P'"  :width="25" :height="25" iconColor="#FFFF"/>
                      <iconEnv v-else-if="marker.device === 'T'"  :width="25" :height="25" iconColor="#FFFF"/>
                      <iconAirflow v-else-if="marker.device === 'F'"  :width="25" :height="25" iconColor="#FFFF"/>
                    </l-icon>

                    <l-popup>
                       <gridPrincipalItem
                          :img="getImgUrl(marker.type)"
                          :name="marker.tooltip"
                          :description="$t('Labels.Alias')"
                        ></gridPrincipalItem>
                        <vs-divider/>
                          <div class="container-items">
                            <valueItem v-bind:key="index" v-for="(value,index) in marker.value"
                              :value="value.value"
                              :description="value.label"
                              :unit="value.unidad"
                              :img="getImgUrl(value.label)"
                            ></valueItem>
                          </div>
                          <vs-divider/>
                          <valueItem
                            :value="marker.date.split(' ')[0]"
                            :description="marker.date.split(' ')[1]"
                            img="fecha"
                          ></valueItem>

                          <alertItem :status="marker.alert === 1? true: false"></alertItem>

                          <div class="text-center">
                            <vs-button color="primary"  size="small" @click="deviceInformation(marker.id, marker.device)">Ver Más</vs-button>
                          </div>
                    </l-popup>

                  </l-marker>
                </v-marker-cluster>
            </l-map>
        </div>

      </vx-card>
    </div>

  </div>
</template>

<script>
import { request } from '@/request.js'
import { empty } from '@/helpers.js'
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LControl,
  LControlLayers
} from 'vue2-leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/Vue2LeafletMarkercluster'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import alertItem from '@/components/alertItem/alertItem.vue'
import iconAgro from '@/components/icons/iconAgro'
import iconAirflow from '@/components/icons/iconAirflow'
import iconDoor from '@/components/icons/iconDoor'
import iconEnv from '@/components/icons/iconEnv'
import iconEnergy from '@/components/icons/iconEnergy'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
/* global L:true */

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

const nameImages = [
  {
    label: 'Temperatura Ambiental',
    img: 'pressure'
  },
  {
    label: 'Humedad Ambiental',
    img: 'pressure'
  },
  {
    label: 'Iluminación',
    img: 'pressure'
  },
  {
    label: 'Oxígeno Ambiental',
    img: 'pressure'
  },
  {
    label: 'Temperatura del Suelo',
    img: 'globe'
  },
  {
    label: 'Humedad del Suelo',
    img: 'globe'
  },
  {
    label: 'Conductividad Eléctrica del Suelo',
    img: 'globe'
  },
  {
    label: 'Nitrógeno en Suelo',
    img: 'globe'
  },
  {
    label: 'Potasio en Suelo',
    img: 'globe'
  },
  {
    label: 'Sodio el Suelo',
    img: 'globe'
  },
  {
    label: 'PH del Suelo',
    img: 'globe'
  },
  {
    label: 'Batería',
    img: 'battery'
  },
  {
    label: 'Temperatura',
    img: 'temperature'
  },
  {
    label: 'Humedad',
    img: 'humedad'
  },
  {
    label: 'Flujo',
    img: 'flow'
  },
  {
    label: 'Humedad en Suelo',
    img: 'droplet'
  },
  {
    label: 'Presión',
    img: 'pressure'
  },
  {
    label: 'Estatus',
    img: 'doors_gray'
  },
  {
    label: 'Energia',
    img: 'kws'
  },
  {
    label: 'Temperatura del Suelo',
    img: 'temperature'
  },
  {
    label: 'Temperatura Ambiente',
    img: 'pressure'
  },
  {
    label: 'Nivel de Lluvia',
    img: 'lluvia'
  },
  {
    label: 'Nivel de Luz',
    img: 'nivel_luz'
  },
  {
    label: 'Voltaje A',
    img: 'voltaje_a'
  },
  {
    label: 'Corriente A',
    img: 'corriente_a'
  },
  {
    label: 'Potencia A',
    img: 'potencia_a'
  },
  {
    label: 'Potencia Reactiva A',
    img: 'potencia_r_a'
  },
  {
    label: 'Factor A',
    img: 'factor_a'
  },
  {
    label: 'Voltaje B',
    img: 'voltaje_b'
  },
  {
    label: 'Corriente B',
    img: 'corriente_b'
  },
  {
    label: 'Potencia B',
    img: 'potencia_b'
  },
  {
    label: 'Potencia Reactiva B',
    img: 'potencia_r_b'
  },
  {
    label: 'Factor B',
    img: 'factor_b'
  },
  {
    label: 'Voltaje C',
    img: 'voltaje_c'
  },
  {
    label: 'Corriente C',
    img: 'corriente_c'
  },
  {
    label: 'Potencia C',
    img: 'potencia_c'
  },
  {
    label: 'Potencia Reactiva C',
    img: 'potencia_r_c'
  },
  {
    label: 'Factor C',
    img: 'factor_c'
  },
  {
    label: 'Puertas',
    img: 'doors'
  },
  {
    label: 'Temperatura y Humedad',
    img: 'envtemperature'
  },
  {
    label: 'Flujo de Aire',
    img: 'airflow'
  },
  {
    label: 'Agro',
    img: 'agro'
  }
]

const URL = {
  T: '/env',
  P: '/doors',
  E: '/energy',
  F: '/airflow',
  A: '/agro'
}

export default {
  name: 'mapa',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LControl,
    LPopup,
    LIcon,
    LControlLayers,
    'v-marker-cluster': Vue2LeafletMarkercluster,
    gridPrincipalItem,
    valueItem,
    alertItem,
    iconAgro,
    iconAirflow,
    iconDoor,
    iconEnv,
    iconEnergy
  },
  data () {
    return {
      filter: {
        type: ''
      },
      tileProviders,
      layersPosition: 'topright',
      center: [20.662396323989693, -103.37640969334421],
      staticAnchor: [12, 27],
      response: [],
      markers: [],
      status_mapa: false,
      showFiltrar: false,
      types: [
        { label: this.$t('Labels.Agro'), value: 'A' },
        { label: this.$t('Labels.AirFlow'), value: 'F' },
        { label: this.$t('Labels.DoorsSensor'), value: 'P' },
        { label: this.$t('Labels.Energy'), value: 'E' },
        { label: this.$t('Labels.EnvTemperature'), value: 'T' }
      ],
      typesSelected: ['A', 'F', 'P', 'E', 'T'],
      allSelected: true,
      positions: [],
      nameImages,
      URL
    }
  },
  methods: {

    async getMapa () {
      const data = {
        url: 'modelo/general/mapa',
        method: 'GET'
      }

      await request(data).then(response => {
        if (!empty(response.data.data)) {
          this.response = response.data.data
          this.markers = []
          this.positions = []
          for (const data of response.data.data) {
            this.addPosition(data)
            this.addMarker(data)
          }
          this.status_mapa = true
          const app = this
          setTimeout(function () {
            const maps = app.$refs.mymap[0].mapObject
            maps.addControl(new L.Control.Fullscreen())
            app.fitBounds()
          }, 10000)
        }
      }).catch(() => {
        this.markers = []
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    getImgUrl (name) {
      const img = nameImages.find(element => {
        return element.label === name
      })
      return img.img
    },

    deviceInformation (uuid, type) {
      this.$router.push(`${URL[type]}/detail/${uuid}`)
    },

    filterMarkers () {
      this.markers = []
      this.positions = []
      this.response.forEach(element => {
        if (this.typesSelected.includes(element.device)) {
          this.addPosition(element)
          this.addMarker(element)
        }
      })
      this.fitBounds()
    },

    addPosition (element) {
      this.positions.push([element.location.split(',')[0], element.location.split(',')[1]])
    },

    addMarker (element) {
      console.log(element.location)
      let value = []
      if (element.value.length > 0) value = JSON.parse(element.value)
      this.markers.push({
        position: { lat: element.location.split(',')[0], lng: element.location.split(',')[1] },
        tooltip: element.alias,
        state: element.status,
        id: element.uuid,
        type: element.type,
        device: element.device,
        date: element.updated_at,
        value,
        draggable: false,
        visible: true
      })
    },
    fitBounds () {
      const maps = this.$refs.mymap.mapObject
      maps.fitBounds(this.positions)
    },
    updateMarker (payload, type) {
      this.markers.forEach(toModify => {
        if (toModify.uuid === payload.uuid && toModify.device === type) {
          toModify.state = payload.status
          toModify.date = payload.updated_at
        }
      })
    }
  },
  sockets: {
    agro (payload) {
      this.updateMarker(payload, 'A')
    },
    airflow (payload) {
      this.updateMarker(payload, 'F')
    },
    door (payload) {
      this.updateMarker(payload, 'P')
    },
    energie (payload) {
      this.updateMarker(payload, 'E')
    },
    tempHum (payload) {
      this.updateMarker(payload, 'T')
    }
  },
  created () {
    this.getMapa()
  },
  watch: {
    allSelected (newVal, old) {
      if (newVal === true && old === false) {
        this.typesSelected = []
        this.types.forEach(element => {
          this.typesSelected.push(element.value)
        })
      } else if (newVal === false && old === true && this.typesSelected.length !== (this.types.length - 1)) {
        this.typesSelected = []
      }
    },
    typesSelected (val) {
      if (val.length < this.types.length && val.length !== 0) {
        this.allSelected = false
        this.filterMarkers()
      } else if (val.length === this.types.length) {
        this.allSelected = true
        this.filterMarkers()
      } else if (val.length === 0) {
        this.markers = []
        this.selectMarkers = false
        this.totalCurrent = 0
        this.totalAccumulated = 0
      }
    }
  }
}
</script>
